module.exports = __webpack_public_path__ + "img/ppt.2e1230f8.svg";